import axios from 'axios';
import router from '@/router';
import { useAdminStore } from '@/store/admin';

const subAPI = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT_API,
});

// add a request interceptor to add the token to the header
subAPI.interceptors.request.use(
  (config) => {
    const token = localStorage?.google_auth_token;
    if (token) {
      config.headers.Authorization = `Bearer google_auth_token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

subAPI.interceptors.response.use(
  (response) => {
    const data = response.data;
    if (data?.subStatus === 0) {
      window.dispatchEvent(new CustomEvent('subscription-inactive', { detail: data }));
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      const adminStore = useAdminStore();
      adminStore.isAuthenticated = false;
      router.push('/login');
    }
    return error;
  },
);
export default subAPI;
